// FAQ content for BIU BIU DRIVING — Categoria B (bilingual RO/EN)
// Format: { q: "Question", a: <ReactNode> }

import React from "react";

const RO_ITEMS = [
  {
    q: "Ce vârstă minimă trebuie să am pentru a obține permisul categoria B?",
    a: (
      <>
        <p>Vârsta minimă legală pentru a susține examenul de permis categoria B este de <strong>18 ani împliniți</strong>.</p>
        <p>Totuși, legea permite înscrierea la școala de șoferi cu <strong>3 luni înainte</strong> de împlinirea vârstei minime, adică de la <strong>17 ani și 9 luni</strong>. Proba practică poate fi susținută abia după împlinirea vârstei de 18 ani.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: Art. 24 alin. (4) lit. b) din OUG nr. 195/2002 (Codul rutier) și HG nr. 1391/2006.</p>
      </>
    ),
  },
  {
    q: "Ce documente sunt necesare pentru înscrierea la școala de șoferi?",
    a: (
      <>
        <p>Dosarul de înscriere la o școală de șoferi autorizată trebuie să conțină:</p>
        <ul className="list-disc pl-5 space-y-1.5 marker:text-brand-navy marker:font-bold">
          <li>Cartea de identitate (original și copie)</li>
          <li>Cazier judiciar — gratuit de la secțiile de poliție sau online; trebuie solicitat special pentru „Examen auto”</li>
          <li>Declarație pe propria răspundere că nu există interdicție de prezentare la examen (model furnizat de școală)</li>
          <li><strong>FIȘA MEDICALĂ Grupa I</strong> - cu mențiunea <strong>APT</strong> (ai mai sus <em>Lista unităților medicale autorizate în Brașov</em>, la <em>Documente pentru înscriere</em>)</li>
          <li><strong>AVIZ PSIHOLOGIC</strong> - cu concluzia <strong>APT psihologic școlarizare obținere permis de conducere categoria B</strong></li>
        </ul>
        <p className="text-xs text-brand-muted italic">Bază legală: OUG nr. 195/2002, art. 24; Ordinul MAI nr. 268/2010.</p>
      </>
    ),
  },
  {
    q: "Câte ore de cursuri sunt obligatorii la școala de șoferi?",
    a: (
      <>
        <p>Legea impune un minim de:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>24 de ore de pregătire teoretică</strong> (legislație rutieră, mecanică, prim ajutor, conduită preventivă)</li>
          <li><strong>30 de ore de conducere practică</strong> (cu instructor autorizat, pe drumuri publice)</li>
        </ul>
        <p>O ședință de conducere durează 50 de minute (1 oră remunerabilă), iar zilnic se pot face maximum 90 de minute. Cel puțin 6 ore trebuie efectuate în condiții de vizibilitate redusă (seară/noapte).</p>
        <p className="text-xs text-brand-muted italic">Bază legală: HG nr. 1391/2006, Anexa 2; Ordinul MLPDA nr. 268/2010.</p>
      </>
    ),
  },
  {
    q: "Cât durează, în total, școala de șoferi?",
    a: (
      <>
        <p>Durata minimă este de aproximativ <strong>4–6 săptămâni</strong>, în cel mai favorabil caz (ore zilnice, fără întreruperi). Calculul minim: 20 de zile lucrătoare pentru teorie și practică combinate.</p>
        <p>În practică, durata poate fi mai lungă în funcție de:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Disponibilitatea cursantului și a instructorului</li>
          <li>Programarea examenelor la DRPCIV (uneori cu liste de așteptare)</li>
          <li>Eventuale reprogramări de examen</li>
        </ul>
      </>
    ),
  },
  {
    q: "Cât costă, în total, obținerea permisului categoria B în 2025–2026?",
    a: (
      <>
        <p>Costul total variază în funcție de oraș și de tipul de transmisie ales:</p>
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-brand-border-soft">
                <th className="text-left py-2 px-3 font-semibold text-brand-navy">Componentă</th>
                <th className="text-right py-2 px-3 font-semibold text-brand-navy">Cost estimativ</th>
              </tr>
            </thead>
            <tbody className="text-brand-muted">
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Cursuri teoretice + practice (pachet standard)</td><td className="py-2 px-3 text-right">2.000 – 3.800 lei</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Fișă medicală (6 specialiști)</td><td className="py-2 px-3 text-right">120 – 250 lei</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Aviz psihologic</td><td className="py-2 px-3 text-right">80 – 150 lei</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Taxă permis DRPCIV</td><td className="py-2 px-3 text-right">139 lei (fix)</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Mașina școlii la examenul practic (proba la oraș)</td><td className="py-2 px-3 text-right">150 – 250 lei</td></tr>
              <tr><td className="py-2 px-3 font-bold text-brand-navy">Total estimativ</td><td className="py-2 px-3 text-right font-bold text-brand-navy">2.800 – 4.500 lei</td></tr>
            </tbody>
          </table>
        </div>
        <p>Cursurile pe mașină cu transmisie automată sunt cu 200–500 lei mai scumpe. Reprogramarea probei practice adaugă minimum 6 ore suplimentare de conduită.</p>
        <p className="text-brand-navy font-semibold">Cum costurile la combustibil au tot crescut în acest an, ar fi bine să te apuci de cursurile școlii de șoferi acum cât încă mai sunt aceste prețuri.</p>
      </>
    ),
  },
  {
    q: "Ce analize și vizite medicale sunt obligatorii pentru permisul B?",
    a: (
      <>
        <p>Fișa medicală (Grupa I — conducători auto) trebuie avizată de <strong>6 medici specialiști</strong>:</p>
        <ul className="list-decimal pl-5 space-y-1.5">
          <li>Medic de familie (boli cronice incompatibile)</li>
          <li>Oftalmolog (acuitate vizuală, câmp vizual)</li>
          <li>ORL (auz)</li>
          <li>Neurolog</li>
          <li>Psihiatru</li>
          <li>Internist / Medicină generală</li>
        </ul>
        <p>Se adaugă și un <strong>aviz psihologic</strong> de la un psiholog autorizat (instituție separată).</p>
        <p>Fișa medicală are valabilitate de <strong>1 an</strong> de la data eliberării.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: Ordinul MS nr. 1.159/2010 și OUG nr. 195/2002, art. 23 alin. (2) lit. d).</p>
      </>
    ),
  },
  {
    q: "Cum se desfășoară proba teoretică (sala)?",
    a: (
      <>
        <p>Proba teoretică constă într-un chestionar grilă cu:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>26 de întrebări</strong></li>
          <li>Timp alocat: <strong>30 de minute</strong></li>
          <li>Scor minim pentru promovare: <strong>22 de răspunsuri corecte din 26</strong></li>
        </ul>
        <p>Întrebările acoperă: legislația rutieră, semnalizare, reguli de prioritate, conducere preventivă, prim ajutor, mecanică de bază — preluate din baza de date oficială DRPCIV.</p>
        <p>Examenul se desfășoară pe calculator, la sediul DRPCIV sau al Serviciilor Publice Comunitare de Permise și Înmatriculări.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: Ordinul MAI nr. 268/2010.</p>
      </>
    ),
  },
  {
    q: "Pot susține proba teoretică în altă localitate decât cea de domiciliu?",
    a: (
      <>
        <p><strong>Da.</strong> Începând cu o modificare recentă a Codului Rutier, proba teoretică poate fi susținută la <strong>orice autoritate competentă</strong> de pe teritoriul României, nu doar în localitatea de domiciliu.</p>
        <p><strong>Excepție:</strong> Candidații pentru categoriile speciale (Tr, Tr1, Tb, Tv) și candidații cu dizabilități fizice pot fi examinați doar la autoritatea competentă pe raza căreia se află școala de șoferi absolvită.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: OUG nr. 195/2002, modificată.</p>
      </>
    ),
  },
  {
    q: "Cum se desfășoară proba practică (traseul)?",
    a: (
      <>
        <p>Proba practică se desfășoară în condiții reale de trafic, pe un traseu stabilit de Poliția Rutieră. Examinatorul DRPCIV evaluează:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Respectarea regulilor de circulație</li>
          <li>Manevrele obligatorii: pornire, frânare, schimbarea direcției, parcarea, mersul cu spatele</li>
          <li>Comportamentul în intersecții și situații de prioritate</li>
          <li>Conducerea în zone urbane și, dacă e posibil, în afara localității (inclusiv după lăsarea serii)</li>
        </ul>
        <p>Autovehiculul de examinare aparține școlii de șoferi și trebuie să fie dotat cu sistem audio-video funcțional.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: Ordinul MAI nr. 268/2010, art. 14–18.</p>
      </>
    ),
  },
  {
    q: "Ce se întâmplă dacă pic proba teoretică (sala)?",
    a: (
      <>
        <p>Dacă ești declarat respins la proba teoretică, te poți reprograma prin:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Intermediul școlii de șoferi (cea mai simplă variantă)</li>
          <li>Direct pe site-ul DRPCIV (dgpci.mai.gov.ro), folosind codul unic din fișa de școlarizare</li>
        </ul>
        <p>Nu există perioadă minimă de așteptare pentru reprogramarea probei teoretice, dar disponibilitatea locurilor depinde de capacitatea centrului de examinare.</p>
        <p className="text-xs text-brand-muted italic"><strong>Atenție:</strong> Toate reprogramările trebuie să se încadreze în termenul de valabilitate al școlii (12 luni de la absolvire).</p>
      </>
    ),
  },
  {
    q: "Ce se întâmplă dacă pic proba practică (traseul)?",
    a: (
      <>
        <p>Dacă ești declarat respins la proba practică:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Poți reprograma examenul după minimum <strong>15 zile calendaristice</strong> de la data probei nepromovate</li>
          <li>Ești obligat să efectuezi cel puțin <strong>3 ședințe suplimentare de condus (6 ore)</strong> înainte de reprogramare</li>
          <li>La reprogramare prezinți la DRPCIV: dosarul cursantului + dovada celor 3 ședințe suplimentare</li>
          <li><strong>PROGRAMAREA și REPROGRAMAREA</strong> pentru proba practică (traseu) se face în intervalul <strong>luni – joi, orele 14:00 – 16:00</strong>, la sediul Serviciului Public Comunitar Regim Permise de Conducere și Înmatriculare a Vehiculelor Brașov din <strong>Strada Turnului 13, 500152 Brașov</strong>.</li>
        </ul>
        <p className="text-xs text-brand-muted italic">Bază legală: Ordinul MAI nr. 268/2010.</p>
      </>
    ),
  },
  {
    q: "Cât timp este valabilă fișa de școlarizare după absolvire?",
    a: (
      <>
        <p>Fișa de școlarizare (dovada absolvirii cursurilor) este valabilă <strong>12 luni (1 an)</strong> de la data absolvirii — adică de la data efectuării ultimei ore de conducere.</p>
        <p>Dacă în acest interval nu promovezi ambele probe ale examenului, trebuie să <strong>reiei integral</strong> procesul: 24 ore teorie + 30 ore practică + dosar nou.</p>
        <p className="text-xs text-brand-muted italic"><strong>Recomandare:</strong> susține examenul cât mai rapid după absolvire — informațiile sunt proaspete, iar legislația se poate modifica.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: HG nr. 1391/2006.</p>
      </>
    ),
  },
  {
    q: "Ce vehicule pot conduce cu permisul categoria B?",
    a: (
      <>
        <p>Cu permisul categoria B poți conduce:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Autoturisme și autoutilitare cu MMA de maximum <strong>3.500 kg</strong> și cel mult 8 locuri pentru pasageri</li>
          <li>Ansamblu autovehicul + remorcă ușoară cu MMA a remorcii de până la <strong>750 kg</strong></li>
          <li>Ansamblu cu MMA totală de max. 4.250 kg, dacă MMA remorcii nu depășește 3.500 kg (cu cod <strong>B96</strong>)</li>
          <li>Mopede și scutere categoria AM (max. 50 cmc, max. 45 km/h) — fără pregătire suplimentară</li>
          <li>Motociclete categoria A1 cu transmisie automată, max. 125 cmc, max. 11 kW — în condiții speciale</li>
        </ul>
        <p className="text-xs text-brand-muted italic">Bază legală: OUG nr. 195/2002, art. 24 alin. (2) lit. b).</p>
      </>
    ),
  },
  {
    q: "Ce înseamnă codul 78 pe permis? Pot conduce orice mașină dacă am dat examenul pe automată?",
    a: (
      <>
        <p><strong>Codul 78</strong> este o restricție înscrisă pe permis care indică faptul că titularul a susținut proba practică <strong>exclusiv pe vehicul cu transmisie automată</strong>.</p>
        <p>Dacă ai codul 78 pe permis, <strong>nu ești autorizat să conduci vehicule cu cutie de viteze manuală</strong>.</p>
        <p>Pentru a elimina restricția, trebuie să urmezi un curs suplimentar de <strong>6 ore de conduită</strong> pe o mașină cu cutie manuală și să promovezi o nouă probă practică pe mașină manuală la DRPCIV.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: Directiva 2006/126/CE; HG nr. 1391/2006, Anexa nr. 3.</p>
      </>
    ),
  },
  {
    q: "Pot tracta o remorcă cu permisul B? Ce este categoria B96 și BE?",
    a: (
      <>
        <p>Cu permisul <strong>B simplu</strong> poți tracta o remorcă cu MMA de maximum 750 kg, dacă ansamblul total nu depășește 4.250 kg.</p>
        <p><strong>Categoria B96 (cod 96)</strong> — permite tracțiunea unui ansamblu cu MMA totală de până la 4.250 kg, chiar dacă remorca depășește 750 kg. Se obține printr-un curs practic de minimum <strong>7 ore</strong> la o școală autorizată, <strong>fără examen la DRPCIV</strong>.</p>
        <p><strong>Categoria BE</strong> — necesară pentru ansambluri cu MMA a remorcii peste 750 kg, când totalul depășește 4.250 kg. Presupune examen complet (teorie + practică).</p>
        <p className="text-xs text-brand-muted italic">Bază legală: OUG nr. 195/2002, art. 24; HG nr. 971/2022.</p>
      </>
    ),
  },
  {
    q: "Pot conduce o motocicletă de 125 cmc cu permisul categoria B?",
    a: (
      <>
        <p><strong>Da</strong>, din august 2024, cu respectarea cumulativă a următoarelor condiții:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Minimum <strong>24 de ani</strong> împliniți</li>
          <li>Permisul categoria B deținut de cel puțin <strong>2 ani</strong></li>
          <li>Curs practic de minimum <strong>10 ore</strong> (4 ore poligon + 6 ore trafic) la o școală autorizată</li>
        </ul>
        <p>Motocicleta trebuie să fie cu <strong>transmisie automată</strong>, max. 125 cmc, putere max. 11 kW, raport putere/greutate max. 0,1 kW/kg (categoria A1).</p>
        <p>Nu este necesar examen suplimentar la poliție.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: OUG nr. 195/2002, art. 24^1 alin. (2) lit. g^2); Ordinul MAI din august 2024.</p>
      </>
    ),
  },
  {
    q: "Cât timp este valabil permisul categoria B și cum se reînnoiește?",
    a: (
      <>
        <p>Permisul categoria B are o valabilitate administrativă de <strong>10 ani</strong>. La expirare, trebuie reînnoit.</p>
        <p><strong>Acte necesare la reînnoire:</strong></p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Carte de identitate (original + copie)</li>
          <li>Fișă medicală actualizată (valabilă 1 an)</li>
          <li>Permisul vechi</li>
          <li>Taxa de 139 lei</li>
        </ul>
        <p>Reînnoirea se face la DRPCIV sau online (pentru duplicat, din iunie 2024 există și serviciu online pe site-ul DGPCI).</p>
        <p className="text-xs text-brand-muted italic"><strong>Atenție:</strong> Conducerea cu permisul expirat se sancționează cu 6–8 puncte de amendă (1.212 – 1.616 lei în 2025).</p>
      </>
    ),
  },
  {
    q: "Pot începe școala de șoferi dacă am cazier judiciar?",
    a: (
      <>
        <p>Prezența unui cazier judiciar <strong>nu împiedică automat</strong> înscrierea la școala de șoferi. Legea interzice eliberarea permisului persoanelor condamnate definitiv pentru:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Infracțiuni la regimul circulației rutiere</li>
          <li>Omor, loviri cauzatoare de moarte, vătămare corporală gravă, tâlhărie sau furt de autovehicul</li>
        </ul>
        <p>Orice altă înregistrare (abateri mai puțin grave, infracțiuni fără legătură cu circulația) trebuie analizată individual.</p>
        <p>Candidații depun o declarație pe propria răspundere; extrasul de cazier este obținut de autoritatea de examinare prin consimțământul candidatului.</p>
        <p className="text-sm bg-white border-l-4 border-brand-orange rounded-r-xl p-3">
          <strong>Candidații cu mențiuni în cazierul judiciar TREBUIE</strong> să atașeze la dosar și copie după <strong>ÎNCHEIEREA JUDECĂTOREASCĂ</strong>, pentru ca agentul responsabil cu programarea la proba teoretică să poată analiza situația în cunoștință de cauză.
        </p>
        <p className="text-xs text-brand-muted italic">Bază legală: OUG nr. 195/2002, art. 24 alin. (6).</p>
      </>
    ),
  },
  {
    q: "Care sunt documentele necesare pentru dosarul de examen la DRPCIV?",
    a: (
      <>
        <p>Dosarul depus la DRPCIV trebuie să conțină:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Cerere tip (formular DRPCIV)</li>
          <li>Fișa de școlarizare emisă de școala de șoferi (valabilă 1 an), cu avizul medical inclus</li>
          <li>Declarație de consimțământ privind eliberarea extrasului de cazier judiciar</li>
          <li>Dovada achitării taxei de 139 lei pentru permisul de conducere, conform <a href="https://www.apps.ro/informatii-incasare-contravaloare-taxe/" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold underline hover:text-brand-orange">apps.ro</a></li>
        </ul>

        <div className="mt-3 rounded-2xl bg-brand-cream border border-brand-border-soft p-4 sm:p-5 space-y-3">
          <p className="font-semibold text-brand-navy">În scopul încasării contravalorii permiselor de conducere, RA-APPS a deschis următoarele conturi de plată:</p>
          <div className="grid sm:grid-cols-2 gap-3">
            <div className="bg-white rounded-xl p-3 border border-brand-border-soft">
              <p className="text-xs uppercase tracking-wider font-bold text-brand-orange-deep mb-1">BCR</p>
              <p className="font-mono text-sm text-brand-navy break-all select-all">RO94 RNCB 0082 0003 6733 1018</p>
            </div>
            <div className="bg-white rounded-xl p-3 border border-brand-border-soft">
              <p className="text-xs uppercase tracking-wider font-bold text-brand-orange-deep mb-1">CEC Bank</p>
              <p className="font-mono text-sm text-brand-navy break-all select-all">RO05 CECE B000 30RO N116 2250</p>
            </div>
          </div>
          <p className="text-sm"><strong>Beneficiar:</strong> Regia Autonomă – Administrația Patrimoniului Protocolului de Stat.</p>
          <div>
            <p className="font-semibold text-brand-navy text-sm mb-1.5">Mijloace de plată acceptate:</p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>Virament bancar</li>
              <li>Mijloace de plată online</li>
              <li>Sistemul Național Electronic de Plată Online (S.N.E.P) – <a href="https://www.ghiseul.ro" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline">www.ghișeul.ro</a></li>
              <li>Prin site-ul D.R.P.C.I.V – <a href="https://www.drpciv.ro" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline">www.drpciv.ro</a></li>
              <li>Mandat poștal sau alte mijloace prevăzute de lege</li>
            </ul>
          </div>
          <p className="text-sm bg-white border-l-4 border-brand-orange rounded-r-xl p-3">
            În situația în care nu primiți dovada plății, contactați <strong>Ghișeul.ro</strong> la <a href="tel:+40213032997" className="text-brand-orange-deep font-semibold hover:underline">021.303.29.97</a> (Tasta 3).
          </p>
          <p className="text-sm">
            <strong>Important:</strong> la plata prin transfer bancar, precizează în detaliile de plată: <strong>Numele, Prenumele și CNP-ul</strong> titularului.
          </p>
          <p className="text-sm">
            <strong>Plata cash</strong> se poate efectua prin automatele CEC Bank – <a href="https://selfpay.ro/localizare/" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline break-all">selfpay.ro/localizare</a>.
          </p>
        </div>

        <p>Sursă oficială: <a href="https://dgpci.mai.gov.ro/document-details/taxe/5f8d47b07d66a112ac8acec4" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline break-all">dgpci.mai.gov.ro – informații taxe</a></p>
        <p className="text-xs text-brand-muted italic">Bază legală: Ordinul MAI nr. 268/2010.</p>
      </>
    ),
  },
  {
    q: "În cât timp primesc permisul după ce am promovat ambele probe?",
    a: (
      <>
        <p>După promovarea ambelor probe, permisul de conducere este emis și eliberat în aproximativ <strong>5–15 zile lucrătoare</strong>.</p>
        <p>Documentul poate fi:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Ridicat personal de la sediul DRPCIV/SPCRIV unde a fost depus dosarul</li>
          <li>Trimis prin poștă (la cerere)</li>
        </ul>
        <p>Până la primirea permisului definitiv, examinatorul îți eliberează un <strong>document provizoriu cu drept de circulație</strong>.</p>
        <p className="text-xs text-brand-muted italic">Bază legală: HG nr. 1391/2006; OUG nr. 195/2002, art. 23 alin. (5).</p>
      </>
    ),
  },
];

const EN_ITEMS = [
  {
    q: "What is the minimum age required to obtain a Category B driving licence?",
    a: (
      <>
        <p>The legal minimum age to sit the Category B driving exam is <strong>18 years</strong>.</p>
        <p>However, the law allows enrollment in driving school <strong>3 months before</strong> reaching the minimum age — that is, from <strong>17 years and 9 months</strong>. The practical exam can only be taken after turning 18.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: Art. 24 (4) b) of GEO no. 195/2002 (Road Code) and GD no. 1391/2006.</p>
      </>
    ),
  },
  {
    q: "What documents are required to enroll in driving school?",
    a: (
      <>
        <p>The enrollment file at an authorized driving school must contain:</p>
        <ul className="list-disc pl-5 space-y-1.5 marker:text-brand-navy marker:font-bold">
          <li>National ID card (original and copy)</li>
          <li>Criminal record — free of charge from police stations or online; must be specifically requested for &ldquo;Driving Exam&rdquo;</li>
          <li>Sworn declaration that there is no prohibition to sit the exam (template provided by the school)</li>
          <li><strong>MEDICAL CERTIFICATE Group I</strong> - with the mention <strong>FIT</strong> (see above <em>List of authorized medical units in Brașov</em>, under <em>Documents for enrollment</em>)</li>
          <li><strong>PSYCHOLOGICAL EVALUATION</strong> - with the conclusion <strong>FIT for psychological schooling to obtain Category B driving licence</strong></li>
        </ul>
        <p className="text-xs text-brand-muted italic">Legal basis: GEO no. 195/2002, art. 24; MAI Order no. 268/2010.</p>
      </>
    ),
  },
  {
    q: "How many hours of classes are mandatory at driving school?",
    a: (
      <>
        <p>The law requires a minimum of:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>24 hours of theoretical training</strong> (road law, mechanics, first aid, defensive driving)</li>
          <li><strong>30 hours of practical driving</strong> (with authorized instructor, on public roads)</li>
        </ul>
        <p>A driving session lasts 50 minutes (1 billable hour), and daily practice is capped at 90 minutes. At least 6 hours must be completed in low-visibility conditions (evening/night).</p>
        <p className="text-xs text-brand-muted italic">Legal basis: GD no. 1391/2006, Annex 2; MLPDA Order no. 268/2010.</p>
      </>
    ),
  },
  {
    q: "How long does driving school take in total?",
    a: (
      <>
        <p>The minimum duration is approximately <strong>4–6 weeks</strong>, in the best-case scenario (daily lessons, no interruptions). Minimum calculation: 20 working days for combined theory and practice.</p>
        <p>In practice, duration may be longer depending on:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Student and instructor availability</li>
          <li>DRPCIV exam scheduling (sometimes with waiting lists)</li>
          <li>Potential exam rescheduling</li>
        </ul>
      </>
    ),
  },
  {
    q: "What is the total cost of obtaining a Category B licence in 2025–2026?",
    a: (
      <>
        <p>The total cost varies depending on the city and chosen transmission type:</p>
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-brand-border-soft">
                <th className="text-left py-2 px-3 font-semibold text-brand-navy">Item</th>
                <th className="text-right py-2 px-3 font-semibold text-brand-navy">Estimated cost</th>
              </tr>
            </thead>
            <tbody className="text-brand-muted">
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Theory + practical courses (standard package)</td><td className="py-2 px-3 text-right">2,000 – 3,800 LEI</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Medical certificate (6 specialists)</td><td className="py-2 px-3 text-right">120 – 250 LEI</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">Psychological evaluation</td><td className="py-2 px-3 text-right">80 – 150 LEI</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">DRPCIV licence fee</td><td className="py-2 px-3 text-right">139 LEI (fixed)</td></tr>
              <tr className="border-b border-brand-border-soft/60"><td className="py-2 px-3">School car for practical exam (city route)</td><td className="py-2 px-3 text-right">150 – 250 LEI</td></tr>
              <tr><td className="py-2 px-3 font-bold text-brand-navy">Estimated total</td><td className="py-2 px-3 text-right font-bold text-brand-navy">2,800 – 4,500 LEI</td></tr>
            </tbody>
          </table>
        </div>
        <p>Courses on automatic transmission cars are 200–500 LEI more expensive. Rescheduling the practical exam adds a minimum of 6 additional driving hours.</p>
        <p className="text-brand-navy font-semibold">With fuel costs rising this year, it&rsquo;s wise to start driving school now, while these prices are still available.</p>
      </>
    ),
  },
  {
    q: "What medical checks are required for the Category B licence?",
    a: (
      <>
        <p>The medical certificate (Group I — drivers) must be approved by <strong>6 specialist doctors</strong>:</p>
        <ul className="list-decimal pl-5 space-y-1.5">
          <li>Family doctor (chronic incompatible conditions)</li>
          <li>Ophthalmologist (visual acuity, field of vision)</li>
          <li>ENT (hearing)</li>
          <li>Neurologist</li>
          <li>Psychiatrist</li>
          <li>Internist / General medicine</li>
        </ul>
        <p>A <strong>psychological evaluation</strong> from an authorized psychologist is also required (separate institution).</p>
        <p>The medical certificate is valid for <strong>1 year</strong> from the date of issue.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: MS Order no. 1159/2010 and GEO no. 195/2002, art. 23 (2) d).</p>
      </>
    ),
  },
  {
    q: "How does the theory exam work?",
    a: (
      <>
        <p>The theory exam is a multiple-choice test with:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>26 questions</strong></li>
          <li>Time allotted: <strong>30 minutes</strong></li>
          <li>Minimum passing score: <strong>22 correct answers out of 26</strong></li>
        </ul>
        <p>Questions cover: road legislation, signaling, priority rules, defensive driving, first aid, basic mechanics — taken from the official DRPCIV database.</p>
        <p>The exam is taken on a computer, at DRPCIV or Community Public Services for Licences and Registrations offices.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: MAI Order no. 268/2010.</p>
      </>
    ),
  },
  {
    q: "Can I sit the theory exam in a different city than my residence?",
    a: (
      <>
        <p><strong>Yes.</strong> Following a recent amendment to the Road Code, the theory exam can be taken at <strong>any competent authority</strong> across Romania, not just in your city of residence.</p>
        <p><strong>Exception:</strong> Candidates for special categories (Tr, Tr1, Tb, Tv) and candidates with physical disabilities can only be examined at the authority within whose jurisdiction the driving school they attended is located.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: GEO no. 195/2002, amended.</p>
      </>
    ),
  },
  {
    q: "How does the practical (route) exam work?",
    a: (
      <>
        <p>The practical exam takes place in real traffic conditions, on a route established by the Traffic Police. The DRPCIV examiner evaluates:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Compliance with traffic rules</li>
          <li>Mandatory maneuvers: starting, braking, changing direction, parking, reversing</li>
          <li>Behavior at intersections and priority situations</li>
          <li>Driving in urban areas and, if possible, outside the city (including after nightfall)</li>
        </ul>
        <p>The exam vehicle belongs to the driving school and must be equipped with a functional audio-video system.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: MAI Order no. 268/2010, art. 14–18.</p>
      </>
    ),
  },
  {
    q: "What happens if I fail the theory exam?",
    a: (
      <>
        <p>If you are declared failed at the theory exam, you can reschedule via:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>The driving school (easiest option)</li>
          <li>Directly on the DRPCIV website (dgpci.mai.gov.ro), using the unique code from your enrollment file</li>
        </ul>
        <p>There is no minimum waiting period to reschedule the theory exam, but slot availability depends on the exam center capacity.</p>
        <p className="text-xs text-brand-muted italic"><strong>Attention:</strong> All rescheduling must fall within the school validity period (12 months from graduation).</p>
      </>
    ),
  },
  {
    q: "What happens if I fail the practical (route) exam?",
    a: (
      <>
        <p>If you fail the practical exam:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>You can reschedule the exam after a minimum of <strong>15 calendar days</strong> from the failed attempt</li>
          <li>You are required to complete at least <strong>3 additional driving sessions (6 hours)</strong> before rescheduling</li>
          <li>At rescheduling, present at DRPCIV: student file + proof of the 3 additional sessions</li>
          <li><strong>SCHEDULING and RESCHEDULING</strong> for the practical exam (route) is done from <strong>Monday to Thursday, 14:00 – 16:00</strong>, at the Brașov Community Public Service for Driving Licences and Vehicle Registration, <strong>Strada Turnului 13, 500152 Brașov</strong>.</li>
        </ul>
        <p className="text-xs text-brand-muted italic">Legal basis: MAI Order no. 268/2010.</p>
      </>
    ),
  },
  {
    q: "How long is the enrollment file valid after graduation?",
    a: (
      <>
        <p>The enrollment file (proof of course completion) is valid for <strong>12 months (1 year)</strong> from the graduation date — that is, from the date of the last driving lesson.</p>
        <p>If you do not pass both exams within this interval, you must <strong>restart the entire process</strong>: 24 hours theory + 30 hours practice + new file.</p>
        <p className="text-xs text-brand-muted italic"><strong>Recommendation:</strong> take the exam as quickly as possible after graduation — the information is fresh, and legislation may change.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: GD no. 1391/2006.</p>
      </>
    ),
  },
  {
    q: "What vehicles can I drive with a Category B licence?",
    a: (
      <>
        <p>With a Category B licence you can drive:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Cars and light commercial vehicles with a MAM of maximum <strong>3,500 kg</strong> and up to 8 passenger seats</li>
          <li>Vehicle + light trailer combination with trailer MAM up to <strong>750 kg</strong></li>
          <li>Combination with total MAM up to 4,250 kg, if trailer MAM doesn&rsquo;t exceed 3,500 kg (with code <strong>B96</strong>)</li>
          <li>Mopeds and scooters in category AM (max. 50 cc, max. 45 km/h) — no additional training</li>
          <li>Category A1 motorcycles with automatic transmission, max. 125 cc, max. 11 kW — under special conditions</li>
        </ul>
        <p className="text-xs text-brand-muted italic">Legal basis: GEO no. 195/2002, art. 24 (2) b).</p>
      </>
    ),
  },
  {
    q: "What does code 78 mean on the licence? Can I drive any car if I took the exam on automatic?",
    a: (
      <>
        <p><strong>Code 78</strong> is a restriction on the driving licence indicating that the holder took the practical exam <strong>exclusively on a vehicle with automatic transmission</strong>.</p>
        <p>If you have code 78 on your licence, <strong>you are not authorized to drive vehicles with manual transmission</strong>.</p>
        <p>To remove this restriction, you must take an additional course of <strong>6 driving hours</strong> on a manual car and pass a new practical exam on a manual car at DRPCIV.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: Directive 2006/126/EC; GD no. 1391/2006, Annex 3.</p>
      </>
    ),
  },
  {
    q: "Can I tow a trailer with a B licence? What are B96 and BE categories?",
    a: (
      <>
        <p>With a plain <strong>B licence</strong> you can tow a trailer with MAM of maximum 750 kg, if the total combination doesn&rsquo;t exceed 4,250 kg.</p>
        <p><strong>Category B96 (code 96)</strong> — allows towing a combination with total MAM up to 4,250 kg, even if the trailer exceeds 750 kg. Obtained through a practical course of at least <strong>7 hours</strong> at an authorized school, <strong>without a DRPCIV exam</strong>.</p>
        <p><strong>Category BE</strong> — required for combinations with trailer MAM over 750 kg, when the total exceeds 4,250 kg. Requires a complete exam (theory + practice).</p>
        <p className="text-xs text-brand-muted italic">Legal basis: GEO no. 195/2002, art. 24; GD no. 971/2022.</p>
      </>
    ),
  },
  {
    q: "Can I ride a 125 cc motorcycle with a Category B licence?",
    a: (
      <>
        <p><strong>Yes</strong>, since August 2024, subject to the cumulative fulfillment of these conditions:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Minimum <strong>24 years old</strong></li>
          <li>Category B licence held for at least <strong>2 years</strong></li>
          <li>Practical course of at least <strong>10 hours</strong> (4 hours polygon + 6 hours traffic) at an authorized school</li>
        </ul>
        <p>The motorcycle must have <strong>automatic transmission</strong>, max. 125 cc, max. 11 kW power, power-to-weight ratio max. 0.1 kW/kg (category A1).</p>
        <p>No additional exam at the police is required.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: GEO no. 195/2002, art. 24^1 (2) g^2); MAI Order of August 2024.</p>
      </>
    ),
  },
  {
    q: "How long is the Category B licence valid and how do I renew it?",
    a: (
      <>
        <p>The Category B licence has an administrative validity of <strong>10 years</strong>. Upon expiration, it must be renewed.</p>
        <p><strong>Documents needed for renewal:</strong></p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>ID card (original + copy)</li>
          <li>Updated medical certificate (valid for 1 year)</li>
          <li>Old licence</li>
          <li>Fee of 139 LEI</li>
        </ul>
        <p>Renewal is done at DRPCIV or online (for duplicate, since June 2024 there&rsquo;s also an online service on the DGPCI site).</p>
        <p className="text-xs text-brand-muted italic"><strong>Attention:</strong> Driving with an expired licence is sanctioned with 6–8 fine points (1,212 – 1,616 LEI in 2025).</p>
      </>
    ),
  },
  {
    q: "Can I start driving school if I have a criminal record?",
    a: (
      <>
        <p>Having a criminal record <strong>does not automatically prevent</strong> enrollment in driving school. The law prohibits issuing a licence to persons definitively convicted of:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Traffic-related offenses</li>
          <li>Murder, blows causing death, serious bodily harm, robbery or vehicle theft</li>
        </ul>
        <p>Any other record (less serious offenses, non-traffic-related offenses) must be analyzed individually.</p>
        <p>Candidates submit a sworn declaration; the criminal record extract is obtained by the examining authority with the candidate&rsquo;s consent.</p>
        <p className="text-sm bg-white border-l-4 border-brand-orange rounded-r-xl p-3">
          <strong>Candidates with entries in the criminal record MUST</strong> also attach to the file a copy of the <strong>JUDICIAL RULING</strong>, so the agent responsible for scheduling the theory exam can properly analyze the situation.
        </p>
        <p className="text-xs text-brand-muted italic">Legal basis: GEO no. 195/2002, art. 24 (6).</p>
      </>
    ),
  },
  {
    q: "What documents are needed for the DRPCIV exam file?",
    a: (
      <>
        <p>The file submitted to DRPCIV must contain:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Standard application form (DRPCIV form)</li>
          <li>Enrollment file issued by the driving school (valid 1 year), with medical approval included</li>
          <li>Consent declaration for the release of criminal record extract</li>
          <li>Proof of payment of the 139 LEI fee for the driving licence, per <a href="https://www.apps.ro/informatii-incasare-contravaloare-taxe/" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold underline hover:text-brand-orange">apps.ro</a></li>
        </ul>

        <div className="mt-3 rounded-2xl bg-brand-cream border border-brand-border-soft p-4 sm:p-5 space-y-3">
          <p className="font-semibold text-brand-navy">For the collection of driving licence fees, RA-APPS has opened the following payment accounts:</p>
          <div className="grid sm:grid-cols-2 gap-3">
            <div className="bg-white rounded-xl p-3 border border-brand-border-soft">
              <p className="text-xs uppercase tracking-wider font-bold text-brand-orange-deep mb-1">BCR</p>
              <p className="font-mono text-sm text-brand-navy break-all select-all">RO94 RNCB 0082 0003 6733 1018</p>
            </div>
            <div className="bg-white rounded-xl p-3 border border-brand-border-soft">
              <p className="text-xs uppercase tracking-wider font-bold text-brand-orange-deep mb-1">CEC Bank</p>
              <p className="font-mono text-sm text-brand-navy break-all select-all">RO05 CECE B000 30RO N116 2250</p>
            </div>
          </div>
          <p className="text-sm"><strong>Beneficiary:</strong> Autonomous Administration – State Protocol Property Administration.</p>
          <div>
            <p className="font-semibold text-brand-navy text-sm mb-1.5">Accepted payment methods:</p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>Bank transfer</li>
              <li>Online payment methods</li>
              <li>National Online Payment System (S.N.E.P) – <a href="https://www.ghiseul.ro" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline">www.ghișeul.ro</a></li>
              <li>Via the D.R.P.C.I.V website – <a href="https://www.drpciv.ro" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline">www.drpciv.ro</a></li>
              <li>Postal money order or other means provided by law</li>
            </ul>
          </div>
          <p className="text-sm bg-white border-l-4 border-brand-orange rounded-r-xl p-3">
            If you do not receive proof of payment, contact <strong>Ghișeul.ro</strong> at <a href="tel:+40213032997" className="text-brand-orange-deep font-semibold hover:underline">021.303.29.97</a> (Press 3).
          </p>
          <p className="text-sm">
            <strong>Important:</strong> for bank transfer payments, specify in the payment details: <strong>Name, Surname and CNP</strong> of the holder.
          </p>
          <p className="text-sm">
            <strong>Cash payment</strong> can be made at CEC Bank ATMs – <a href="https://selfpay.ro/localizare/" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline break-all">selfpay.ro/localizare</a>.
          </p>
        </div>

        <p>Official source: <a href="https://dgpci.mai.gov.ro/document-details/taxe/5f8d47b07d66a112ac8acec4" target="_blank" rel="noopener noreferrer" className="text-brand-orange-deep font-semibold hover:underline break-all">dgpci.mai.gov.ro – fee information</a></p>
        <p className="text-xs text-brand-muted italic">Legal basis: MAI Order no. 268/2010.</p>
      </>
    ),
  },
  {
    q: "How long until I receive the licence after passing both exams?",
    a: (
      <>
        <p>After passing both exams, the driving licence is issued and delivered within approximately <strong>5–15 working days</strong>.</p>
        <p>The document can be:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Picked up in person from the DRPCIV/SPCRIV office where the file was submitted</li>
          <li>Sent by mail (upon request)</li>
        </ul>
        <p>Until you receive the definitive licence, the examiner issues you a <strong>provisional document with driving rights</strong>.</p>
        <p className="text-xs text-brand-muted italic">Legal basis: GD no. 1391/2006; GEO no. 195/2002, art. 23 (5).</p>
      </>
    ),
  },
];

export const FAQ_ITEMS = {
  ro: RO_ITEMS,
  en: EN_ITEMS,
};

// Backward-compatible default (RO)
export default RO_ITEMS;
